/* eslint-disable max-lines */
import React, { useContext, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { CancelButton, MainDialog } from '../../../../UI';
import SubmitButton from '../../../../UI/Buttons/SubmitButton';
import { PropTypes } from 'prop-types';
import MessagesContext from '../../../../../contexts/messagesContext';
import { useSelector } from 'react-redux';
import { styles } from './PrintFormStructure.styles';
import FormValue from './FormValue';
import printIcon from '../../../../../assets/images/Icon/printIcon.svg';
import { Form, Formik } from 'formik';
import HeaderForm from './HeaderForm';
import Header from './NonFields/Header';
import { Box } from '@material-ui/core';

const PrintFormStructure = ({ entry }) => {
    const [dialog, setDialog] = useState(false);
    const [values, setValues] = useState({});
    const { messages } = useContext(MessagesContext);
    const componentRef = useRef(null);
    const patient = useSelector((state) => state?.patient?.patient?.profile);
    const formStructure = useSelector((state) => state.dynamicForms.formStructure);
    const isRtl = formStructure?.presentation?.rtl;
    const classes = styles({ rtl: isRtl });
    const fields = formStructure?.fields?.length
        ? [...formStructure?.fields]
              ?.sort((a, b) => a.order - b.order)
              ?.filter(
                  (val) => val.data_type !== 'file' && !val?.presentation?.invisible && !val?.hidden
              )
        : [];

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const [loading, setLoading] = React.useState(false);
    const onBeforeGetContentResolve = React.useRef(null);

    const handleOnBeforeGetContent = React.useCallback(() => {
        setLoading(true);

        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;

            setTimeout(() => {
                setLoading(false);
                resolve();
            }, 2000);
        });
    }, [setLoading]);

    const handlePrint = useReactToPrint({
        content: reactToPrintContent,
        onBeforeGetContent: handleOnBeforeGetContent,
        documentTitle: 'Synapps Clinic'
    });

    React.useEffect(() => {
        setValues({
            national_id: patient?.national_id,
            first_name: patient?.first_name,
            last_name: patient?.last_name,
            birthDate: patient?.dob,
            gender: patient?.gender,
            maritalStatus: patient?.marital_status,
            fatherName: patient?.father_name,
            admissionDate: patient?.last_admitted ?? patient?.created
        });
    }, [patient]);

    return (
        <>
            <div className={classes.printLink} onClick={() => setDialog(true)}>
                <img src={printIcon} alt="printIcon" />
                <span>{messages.print}</span>
            </div>
            <MainDialog open={dialog} goBack={() => setDialog(false)} padding="0">
                <Formik
                    initialValues={{ ...values }}
                    onSubmit={async (newValues) => {
                        await setValues({
                            ...newValues,
                            admissionDate: values.admissionDate,
                            birthDate: values.birthDate,
                            dischargDate: values.dischargDate,
                            maritalStatus: values.maritalStatus,
                            gender: values.gender
                        });
                        handlePrint();
                    }}
                >
                    <Form>
                        <div className={classes.buttonsContainer}>
                            <SubmitButton
                                isButton
                                handleClick={() => {}}
                                submitText={messages.print}
                                isSubmitting={loading}
                            />
                            <CancelButton
                                cancelText={messages.back}
                                onClick={() => setDialog(false)}
                            />
                        </div>
                        <Box p={3}>
                            <HeaderForm values={values} setValues={setValues} />
                        </Box>
                    </Form>
                </Formik>

                <div
                    style={{
                        position: 'fixed',
                        top: '0',
                        left: '-1000px',
                        visibility: 'hidden',
                        zIndex: '-10'
                    }}
                >
                    <div className={classes.mainContainer} ref={componentRef}>
                        <Header values={values} />

                        <div className={classes.container}>
                            <div className={classes.row}>
                                {fields
                                    ?.filter((val) => !val.parent)
                                    ?.map((field, index) => (
                                        <FormValue
                                            field={field}
                                            key={field.name}
                                            entry={entry}
                                            prevField={index > 0 ? fields[index - 1] : null}
                                            isRtl={isRtl}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </MainDialog>
        </>
    );
};
PrintFormStructure.propTypes = {
    entry: PropTypes.object
};

export default PrintFormStructure;
